import { Trans, t } from "@web-monorepo/i18n/macro";
import { DDSBodyText, DDSButton } from "@web-monorepo/dds";
import PlaybackAction from "src/pods/ideas/components/video/PlaybackAction";
import PlaybackControls from "src/pods/ideas/components/video/PlaybackControls";
import styles from "./WatchVideo.module.css";

type WatchVideoProps = {
  isPlaying?: boolean;
  onPlayOnPhone: VoidFunction;
  onTogglePlay: VoidFunction;
  onForward: (time: number) => void;
  onReplay: (time: number) => void;
};

export default function WatchVideo({ isPlaying, onPlayOnPhone, onTogglePlay, onForward, onReplay }: WatchVideoProps) {
  return (
    <article className={styles.page}>
      <section className={styles.card}>
        <div className={styles.poster}>
          <PlaybackControls className={styles.playbackControls}>
            <PlaybackAction
              icon="replay_10"
              aria-label={t`Replay 10 seconds`}
              data-name="watch_video:replay_10"
              className={styles.outlinePlaybackAction}
              onClick={() => onReplay(10)}
            />
            <PlaybackAction
              icon={isPlaying ? "pause" : "play_arrow"}
              aria-label={isPlaying ? t`Pause video` : t`Play video`}
              data-name="watch_video:toggle_play"
              className={styles.mainPlaybackAction}
              onClick={onTogglePlay}
            />
            <PlaybackAction
              icon="forward_10"
              aria-label={t`Forward 10 seconds`}
              data-name="watch_video:forward_10"
              className={styles.outlinePlaybackAction}
              onClick={() => onForward(10)}
            />
          </PlaybackControls>
          <div className={styles.state}>
            <DDSBodyText>
              <Trans>Video is playing on your computer</Trans>
            </DDSBodyText>
            <DDSButton
              variant="tertiary"
              data-name="watch_video:mojo_show_video_play_on_phone"
              onClick={() => {
                onPlayOnPhone();
              }}
            >
              <Trans>Play on phone instead</Trans>
            </DDSButton>
          </div>
        </div>
      </section>
    </article>
  );
}
